import { Car, Users, Award, Clock } from "lucide-react";

const stats = [
    {
        icon: Car,
        value: "300+",
        label: "Carros vendidos",
        description: "Em nossa história",
    },
    {
        icon: Users,
        value: "98%",
        label: "De Clientes Satisfeitos",
        description: "Em todo Brasil",
    },
    {
        icon: Award,
        value: "20",
        label: "Anos de Mercado",
        description: "De experiência",
    },
    {
        icon: Clock,
        value: "10h",
        label: "Diárias de atendimento",
        description: "Todos os dias!",
    },
]

export default function StatsSection() {
    return (
        <section className="relative py-20 bg-secondary clip-angle">
            <div className="absolute top-0 left-0 w-full h-1 accent-gradient" />
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
                    {stats.map((stat, index) => (
                        <div
                            key={index}
                            className="text-center group animate-scale-in"
                            style={{ animationDelay: `${index * 0.1}s` }}>
                            <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-lg bg-primary/10 border border-primary/20 group-hover:bg-primary/20 group-hover:border-primary/40 transition-all duration-300">
                                <stat.icon className="w-8 h-8 text-primary" />
                            </div>
                            <div className="text-display text-4xl md:text-5xl font-bold text-foreground mb-1">
                                {stat.value}
                            </div>
                            <div className="text-lg font-semibold text-foreground mb-1">
                                {stat.label}
                            </div>
                            <div className="text-sm text-muted-foreground">
                                {stat.description}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}